import {
  ApiBlueprint,
  PageBlueprint,
  createApiFactory,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { backendAuthApiRef } from '@internal/plugin-neo4j-auth-common';
import { RolloutRestApi, rolloutApiRef } from './apis';
import { ROLLOUTS_BASE_URL } from './const';
import { rolloutDetailRouteRef, rootRouteRef } from './routes';

const rolloutApi = ApiBlueprint.make({
  name: 'rollouts-api',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: rolloutApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
          backendAuthApi: backendAuthApiRef,
        },
        factory: ({ discoveryApi, fetchApi, backendAuthApi }) =>
          new RolloutRestApi({ discoveryApi, fetchApi, backendAuthApi }),
      }),
    ),
});

const rolloutPage = PageBlueprint.make({
  params: {
    path: ROLLOUTS_BASE_URL,
    routeRef: rootRouteRef,
    noHeader: true,
    loader: async () => {
      const [{ RolloutPage }, { QueryClientProvider }] = await Promise.all([
        import('./pages/RolloutPage'),
        import('./components/QueryClientProvider'),
      ]);
      return (
        <QueryClientProvider>
          <RolloutPage />
        </QueryClientProvider>
      );
    },
  },
});

const rolloutDetailPage = PageBlueprint.make({
  name: 'detail',
  params: {
    path: `${ROLLOUTS_BASE_URL}/:rolloutId`,
    routeRef: rolloutDetailRouteRef,
    noHeader: true,
    loader: async () => {
      const [{ RolloutDetailPage }, { QueryClientProvider }] =
        await Promise.all([
          import('./pages/RolloutDetailPage'),
          import('./components/QueryClientProvider'),
        ]);
      return (
        <QueryClientProvider>
          <RolloutDetailPage />
        </QueryClientProvider>
      );
    },
  },
});

export default createFrontendPlugin({
  info: {
    packageJson: () => import('../package.json'),
    manifest: () => import('../catalog-info.yaml'),
  },
  pluginId: 'neo4j-rollouts',
  extensions: [rolloutApi, rolloutPage, rolloutDetailPage],
  routes: {
    root: rootRouteRef,
    rolloutDetail: rolloutDetailRouteRef,
  },
});
